/* @generated */

// ../src/typography/link.tsx
import { useTheme } from "@dropbox/dig-foundations";
import classNames from "classnames";
import * as React from "react";

// ../src/typography/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var linkPseudoFocusStyle = "dig-6lejgs14_21-7-0";
var linkPseudoHoverStyle = "dig-6lejgs13_21-7-0";
var linkRecipe = _7a468({ defaultClassName: "dig-6lejgs15_21-7-0", variantClassNames: { hasNoUnderline: { true: "dig-6lejgs16_21-7-0" }, isBold: { true: "dig-6lejgs17_21-7-0" }, primary: { true: "dig-6lejgs18_21-7-0" }, display: { inline: "dig-6lejgs19_21-7-0", "inline-block": "dig-6lejgs1a_21-7-0" } }, defaultVariants: { hasNoUnderline: false, isBold: false, primary: false, display: "inline" }, compoundVariants: [] });
var textRecipe = _7a468({ defaultClassName: "dig-6lejgsc_21-7-0 dig-6lejgs0_21-7-0", variantClassNames: { color: { standard: "dig-6lejgsd_21-7-0", faint: "dig-6lejgse_21-7-0", subtle: "dig-6lejgsf_21-7-0", disabled: "dig-6lejgsg_21-7-0", error: "dig-6lejgsh_21-7-0", inherit: "dig-6lejgsi_21-7-0" }, monospace: { true: "dig-6lejgsj_21-7-0", false: "dig-6lejgsk_21-7-0" }, size: { xlarge: "dig-6lejgsl_21-7-0", large: "dig-6lejgsm_21-7-0", medium: "dig-6lejgsn_21-7-0", small: "dig-6lejgso_21-7-0", xsmall: "dig-6lejgsp_21-7-0" }, variant: { label: "dig-6lejgsq_21-7-0", paragraph: "dig-6lejgsr_21-7-0" }, isBold: { true: "dig-6lejgss_21-7-0" }, withoutLineheight: { true: "dig-6lejgst_21-7-0" }, withoutWrap: { true: "dig-6lejgsu_21-7-0" }, withMargins: { true: "dig-6lejgsv_21-7-0", false: "dig-6lejgsw_21-7-0" } }, defaultVariants: { size: "medium", variant: "paragraph", isBold: false, monospace: false, withMargins: true }, compoundVariants: [[{ variant: "label", size: "xlarge" }, "dig-6lejgsx_21-7-0"], [{ variant: "label", size: "large" }, "dig-6lejgsy_21-7-0"], [{ variant: "label", size: "medium" }, "dig-6lejgsz_21-7-0"], [{ variant: "label", size: "small" }, "dig-6lejgs10_21-7-0"], [{ variant: "label", size: "xsmall" }, "dig-6lejgs11_21-7-0"], [{ monospace: true, isBold: true }, "dig-6lejgs12_21-7-0"]] });
var titleRecipe = _7a468({ defaultClassName: "dig-6lejgs1_21-7-0 dig-6lejgs0_21-7-0", variantClassNames: { color: { standard: "dig-6lejgs2_21-7-0", subtle: "dig-6lejgs3_21-7-0", faint: "dig-6lejgs4_21-7-0", disabled: "dig-6lejgs5_21-7-0", error: "dig-6lejgs6_21-7-0", inherit: "dig-6lejgs7_21-7-0" }, size: { large: "dig-6lejgs8_21-7-0", medium: "dig-6lejgs9_21-7-0", small: "dig-6lejgsa_21-7-0" }, isEmphasized: { true: "dig-6lejgsb_21-7-0" } }, defaultVariants: { size: "medium", isEmphasized: false }, compoundVariants: [] });

// ../src/typography/link.tsx
var Link = React.forwardRef(
  ({
    children,
    className,
    href,
    onClick,
    inverse = false,
    hasNoUnderline = false,
    isBold = false,
    variant = "primary",
    display = "inline",
    _pseudoClass,
    ...rest
  }, ref) => {
    const inverseClassName = useTheme().getInverseProps().className;
    const cls = classNames(
      "dig-Link",
      className,
      {
        // Note that monochromatic variant is the same as surrounding text (i.e.
        // inherited cascading CSS), so no need for any explicit class name here
        // Historically inverse links inherited color
        "dig-Link--primary": variant === "primary" && !inverse,
        "dig-Link--hasNoUnderline": hasNoUnderline,
        "dig-Link--isBold": isBold,
        [linkPseudoHoverStyle]: _pseudoClass === "hover",
        [linkPseudoFocusStyle]: _pseudoClass === "focus",
        [inverseClassName]: inverse
      },
      linkRecipe({
        isBold,
        primary: variant === "primary" && !inverse,
        hasNoUnderline,
        display
      })
    );
    const navigationProps = { onClick };
    switch (typeof href) {
      case "string":
        navigationProps.href = href;
        break;
      case "function":
        navigationProps.href = "#";
        navigationProps.onClick = (evt) => {
          evt.preventDefault();
          href(evt);
          if (onClick) onClick(evt);
        };
        break;
    }
    return /* @__PURE__ */ React.createElement("a", { className: cls, ref, ...navigationProps, ...rest }, children);
  }
);
Link.displayName = "Link";

// ../src/typography/text.tsx
import classNames2 from "classnames";
import * as React2 from "react";
import { useTheme as useTheme2 } from "@dropbox/dig-foundations";
var Text = React2.forwardRef(
  ({
    variant = "paragraph",
    tagName: TagName = "span",
    children,
    className,
    color = "standard",
    size = "medium",
    isBold = false,
    inverse = false,
    monospace = false,
    _withoutLineHeight,
    _withoutWrap,
    _withMargins = true,
    ...rest
  }, ref) => {
    const inverseClassName = useTheme2().getInverseProps().className;
    const cls = classNames2(
      // Note that `inherit` color is the same as surrounding text (i.e.
      // inherited cascading CSS), so no need for any explicit class name here
      "dig-Text",
      `dig-Text--variant-${variant}`,
      `dig-Text--size-${size}`,
      `dig-Text--color-${color}`,
      {
        [inverseClassName]: inverse,
        "dig-Text--size-standard": size === "medium",
        "dig-Text--isBold": isBold,
        "dig-Text--withoutLineheight": _withoutLineHeight,
        "dig-Text--withoutWrap": _withoutWrap,
        "dig-Text--monospace": monospace
      },
      textRecipe({
        variant,
        size,
        monospace,
        color,
        isBold,
        withoutWrap: _withoutWrap,
        withoutLineheight: _withoutLineHeight,
        withMargins: _withMargins
      }),
      className
    );
    return /* @__PURE__ */ React2.createElement(TagName, { ref, className: cls, ...rest }, children);
  }
);
Text.displayName = "Text";

// ../src/typography/title.tsx
import classNames3 from "classnames";
import * as React3 from "react";
import { useTheme as useTheme3 } from "@dropbox/dig-foundations";
var Title = ({
  tagName: TagName = "h2",
  children,
  className,
  color = "standard",
  size = "medium",
  isBold = false,
  inverse = false,
  weightVariant = "normal",
  ...rest
}) => {
  const inverseClassName = useTheme3().getInverseProps().className;
  const cls = classNames3(
    "dig-Title",
    `dig-Title--size-${size}`,
    `dig-Title--color-${color}`,
    {
      "dig-Title--isBold": isBold,
      "dig-Title--isEmphasized": weightVariant === "emphasized",
      // Maintain both classNames simultaneously so a future migration will be easier to
      // try gradually leading up to the breaking change
      "dig-Title--size-standard": size === "medium",
      [inverseClassName]: inverse
    },
    titleRecipe({
      color,
      size,
      isEmphasized: weightVariant === "emphasized" || isBold
    }),
    className
  );
  return /* @__PURE__ */ React3.createElement(TagName, { className: cls, ...rest }, children);
};
Title.displayName = "Title";
export {
  Link,
  Text,
  Title
};
